import React from "react";
import "../styles/faqStyles.css";

export default function Faq() {
  return (
    <div className="container-fluid">
      <div className="text-center text-light">
        <h1 className="mb-5">Frequently Asked Questions</h1>
        <Questions questions="What is Netflix?" />
        <Questions questions="How much does netflix cost?" />
        <Questions questions="Where can I watch?" />
        <Questions questions="How do I cancel?" />
        <Questions questions="What can I watch on netflix?" />
        <div className="search-container mt-5 ">
          <div class="input-group">
            <input className="form-control input" placeholder="Email address" />
            <div class="input-group-append">
              <button class="btn " type="button">
                GET STARTED
              </button>
            </div>
          </div>
        </div>
        <div className="mt-3">
          <p>
            Ready to watch? Enter your email to create or restart your
            membership.
          </p>
        </div>
      </div>
    </div>
  );
}

function Questions({ questions }) {
  return (
    <div className="question-container mt-2">
      <div className="container pl-4 pr-4  question-subcontainer text-light">
        <div>
          <h3>{questions}</h3>
        </div>
        <div>
          <h1>+</h1>
        </div>
      </div>
    </div>
  );
}
